import { DatabaseIdTypes } from '../../Enums/ChoiceEnums'
import { IconTypes } from '../../Enums/UiEnums';

const idMap: Record<DatabaseIdTypes|number, IDatabaseIdTypeInfo> = 
{
	[DatabaseIdTypes.user_id]: 
        { name: "User", typeName: "user_id", explicitName: "User", iconType: IconTypes.User},
	[DatabaseIdTypes.user_group_id]: 
        { name: "Group", typeName: "user_group_id", explicitName: "User Group", iconType: IconTypes.Users }
}

export interface IDatabaseIdTypeInfo
{
    name: string,
    typeName: string,
    explicitName?: string,
    iconType?: IconTypes
}

// Convert the enum to a idTypeName 
export function idTypeName(idType: DatabaseIdTypes): string | undefined
{
    const item = idMap[idType];
    return item?.typeName;
}

export function idTypeInfo(idType: DatabaseIdTypes, alertWhenMissing: boolean = true): IDatabaseIdTypeInfo | undefined
{
    const item = idMap[idType];
    if (!item && alertWhenMissing)
    {
        alert(`Missing idType: ${idType}`);
        return;
    }

    return item;
}

// Get the commone name for a DatabaseIdType
export function commonName(idType: DatabaseIdTypes): string
{
	return idTypeInfo(idType)?.name ?? "???";
}

export function iconType(idType: DatabaseIdTypes): IconTypes|undefined
{
    return idTypeInfo(idType)?.iconType;
}


// Get an alias name for a DatabaseIdType (if one exists)
export function aliasName(idType: DatabaseIdTypes, aliasType: DatabaseIdTypeNameAlias = DatabaseIdTypeNameAlias.explicitName): string|undefined
{
    const item = idTypeInfo(idType);

    let aliasName: string|undefined;
    switch (aliasType)
    {
        case DatabaseIdTypeNameAlias.commonName:
            return commonName(idType);

        case DatabaseIdTypeNameAlias.explicitName:
            return item?.explicitName;

        default:
            return;        
    }
}

// Different alias types
export enum DatabaseIdTypeNameAlias
{
    commonName,
    explicitName
}
